import { render, staticRenderFns } from "./LowFare.vue?vue&type=template&id=9e9f651a&"
import script from "./LowFare.vue?vue&type=script&lang=js&"
export * from "./LowFare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports